import api from "./axios"

export const notificationApi = {
  getNotifications: async () => {
    const res = await api.get("/notifications/");
    return res.data;
  }
};

